import * as Yup from 'yup';
import { CasesGeneralNotification } from '../../../../../../shared/types/modules/cases-general';

export const initialValues: CasesGeneralNotification = {
    notificationClient: '',
};

export const validationSchema = Yup.object({
    notificationClient: Yup.string().required('La notificación es obligatoria'),
});
